
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
import {mapGetters} from "vuex";
export default {
    name: "UnitInfo__sensors_type",
    extends: UnitInfo__sensors_default,
    computed:{
        ...mapGetters([
            "getUnitsHwTypeTitlesByType",
        ]),
        title() {
            return this.$t('Unit.sensors.Hardware')
        },
        value() {
            return (this.getUnitsHwTypeTitlesByType[this.unitHwType] || this.unitHwType)
        },
        icon() {
            return this.showIcon ? false : false //ToDo need create icon
        }
    },
}
</script>

<style scoped>

</style>